import { render } from "./Clothing.component.vue?vue&type=template&id=63fbdf1c"
import script from "./Clothing.component.vue?vue&type=script&lang=js"
export * from "./Clothing.component.vue?vue&type=script&lang=js"

import "./Clothing.component.vue?vue&type=style&index=0&id=63fbdf1c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput});
